export default "__VITE_ASSET__771766f4__"